import MainLayout from "../Pages/SideMenu"

const ProtectedRouteAuth = () => {
    const isLoggedIn = true;
    return isLoggedIn ? <MainLayout /> : <>Login</>
}

export default ProtectedRouteAuth
